import { render, staticRenderFns } from "./ChatPaletteDialog.vue?vue&type=template&id=4079fa3d&lang=pug&"
import script from "./ChatPaletteDialog.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteDialog.vue"
export default component.exports